export default __webpack_public_path__ + "static/switch-494c75cc5a813a3b15837e3ab5865701.jpg";